import {Box, Skeleton, SkeletonText} from '@chakra-ui/react';
import {FC} from 'react';

export const ProviderLogoListSkeleton: FC = () => {
  return (
    <Box>
      <Skeleton w="100px" h="100px" borderRadius="16px" mx="10px" />
      <SkeletonText skeletonHeight="20px" noOfLines={1} mx="10px" mt="15px" />
    </Box>
  );
};
